import React from 'react';
import ReactDOM from 'react-dom';
import { getConfig } from '@byte-design/config';
import { ConfigProvider } from '../config-provider';
import { ImageView } from './ImageView';
export function imageView(props) {
  var container = document.createElement('div');

  var _getConfig = getConfig(),
      locale = _getConfig.locale,
      prefixCls = _getConfig.prefixCls;

  document.body.appendChild(container);

  var handleClose = function handleClose() {
    ReactDOM.unmountComponentAtNode(container);
    document.body.removeChild(container);
  };

  ReactDOM.render(React.createElement(ConfigProvider, {
    locale: locale,
    prefixCls: prefixCls
  }, React.createElement(ImageView, Object.assign({}, props, {
    handleClose: handleClose
  }))), container);
}